export function capitalize(variable) {
	return variable.replace(/^\w/, c => c.toUpperCase());
}